import { PickingInfo } from "@deck.gl/core"
import { AirspaceFeatureType, isValidAirspaceType } from "@nova/constants"
import { useCallback } from "react"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { clearActivePopup, selectActivePopup, setActivePopup } from "features/overview/slice"
import { AIRSPACE_LAYER_IDS } from "./layerIds"
import { AirspaceFeatureRef, PolygonFeature } from "./types"

export const useAirspaceClickHandler = (source: AirspaceFeatureType) => {
    const dispatch = useAppDispatch()
    const shouldOpenPopupOnClick = !(useAppSelector(selectActivePopup)?.type ?? "").startsWith(
        "airspace"
    )
    return useCallback(
        (info: PickingInfo<PolygonFeature>) => {
            if (!shouldOpenPopupOnClick) {
                dispatch(clearActivePopup())
                return
            }
            const object = info.object
            if (object?.id == null) return

            const deck = info.layer?.context.deck
            const clickPoint = info.coordinate
                ? { lat: info.coordinate[1], lng: info.coordinate[0] }
                : undefined
            if (deck && clickPoint) {
                const picks = deck.pickMultipleObjects({
                    x: info.x,
                    y: info.y,
                    radius: 2,
                    layerIds: AIRSPACE_LAYER_IDS,
                })
                const features = picks.reduce((acc, cur) => {
                    const id = cur.object?.id
                    const type = cur.object?.properties?.featureType
                    if (!id || !isValidAirspaceType(type)) return acc
                    acc.push({ type, id: `${cur.object.id}` })
                    return acc
                }, [] as AirspaceFeatureRef[])
                dispatch(
                    features.length === 1
                        ? setActivePopup({
                              type: "airspace",
                              source,
                              id: features[0].id,
                              placementType: "point",
                              point: clickPoint,
                              renderedDimensions: { width: 1, height: 1 },
                          })
                        : setActivePopup({
                              type: "airspaceFeatureList",
                              id: `${Math.random()}`,
                              features,
                              placementType: "point",
                              point: clickPoint,
                              renderedDimensions: { width: 1, height: 1 },
                          })
                )
            }
        },
        [dispatch, shouldOpenPopupOnClick, source]
    )
}
